import { useCallback, useState } from "react"
import { IHallBooking } from "src/domain/entities"
import { hallBookingListService } from "src/domain/services/hallBooking/hallBookingListService"
import { useAuth } from ".."

export function useHallBookingListService(): {
	hallBookingList: IHallBooking[]
	isLoading: boolean
	fetchHallBookingList: (
		filter?: Parameters<typeof hallBookingListService>[0],
	) => Promise<IHallBooking[]>
} {
	const { token } = useAuth()
	const [hallBookingList, setHallBookingList] = useState<IHallBooking[]>([])
	const [isLoading, setIsLoading] = useState(false)

	const fetchHallBookingList = useCallback(
		async (filter: Parameters<typeof hallBookingListService>[0] = {}) => {
			setIsLoading(true)
			filter = {
				...filter,
			}
			const data = await hallBookingListService(filter, token)
			setHallBookingList(data)
			setIsLoading(false)
			return data
		},
		[token],
	)

	return { hallBookingList, isLoading, fetchHallBookingList }
}
